import { createSlice } from '@reduxjs/toolkit'
import { createAsyncActions } from '@/utils/sagas'

const initialState = {
  isFetching: false,
  isInitialized: false,
  isAuthorized: false,
  error: null,
  permissions: [],
  data: {
    accountId: null,
    organizationId: null,
    token: null,
    name: null,
    email: null,
    avatar: null,
  },
  isGhostLogin: false,
  isReseller: false,
}

export const userLogIn = createAsyncActions('user/logIn')
export const userLogOut = createAsyncActions('user/logOut')
export const checkIfUserIsReseller = createAsyncActions('user/checkIfReseller')

const userSlice = createSlice({
  name: 'user',
  initialState,
  extraReducers: ({ addCase }) => {
    addCase(userLogIn.pending, (_, { payload }) => {
      return {
        ...initialState,
        isFetching: true,
        data: {
          ...initialState.data,
          token: payload?.token,
        },
      }
    })

    addCase(
      userLogIn.fulfilled,
      (state, { payload: { permissions, isGhostLogin, ...data } }) => {
        state.isFetching = false
        state.isAuthorized = true
        state.isInitialized = true
        state.data = data
        state.permissions = permissions
        state.isGhostLogin = isGhostLogin
      }
    )

    addCase(userLogIn.rejected, (state, { payload }) => {
      state.isFetching = false
      state.isAuthorized = false
      state.isInitialized = true
      state.error = payload.error
    })

    addCase(userLogOut.fulfilled, () => {
      return { ...initialState, isInitialized: true }
    })

    addCase(userLogOut.rejected, (state, { payload }) => {
      state.error = payload.error
    })

    addCase(checkIfUserIsReseller.fulfilled, (state, { payload }) => {
      state.isReseller = payload.isReseller
    })

    addCase(checkIfUserIsReseller.rejected, (state) => {
      state.isReseller = false
    })
  },
})

export const reducer = userSlice.reducer
